export default {
  loadReviewRequestsSuccess: ({ reviewRequests }, payload) => {
    reviewRequests.items = payload.data;
    reviewRequests.bulkScheduleRunning = payload.bulkScheduleRunning;
    reviewRequests.pagination.totalItems = payload.recordsTotal;
    reviewRequests.filteredRecords = payload.filteredRecords;
  },
  setPagination({ reviewRequests }, payload) {
    reviewRequests.pagination = payload;
  },
  sendNowSuccess({ reviewRequests }, orderId) {
    reviewRequests.items = reviewRequests.items.map(el => {
      const newEl = el;
      if (el.reviewRequestId == orderId) {
        newEl.received = true;
        newEl.sendAt = new Date();
      }
      return newEl;
    });
  },
  cancelSuccess({ reviewRequests }, orderId) {
    reviewRequests.items = reviewRequests.items.map(el => {
      const newEl = el;
      if (el.reviewRequestId == orderId) {
        newEl.send = false;
      }
      return newEl;
    });
  },
  loadReviewRequestsPerMonthSuccess: ({ reviewRequestsPerMonth }, payload) => {
    reviewRequestsPerMonth.data = payload;
    reviewRequestsPerMonth.loaded = true;
  },
};
